import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { Image } from "hesus-ui-kit";
import { Tooltip } from "react-tooltip";
import * as moment from "moment";
import chevronBottom from "@icons/chevron/bottom.svg";
import transportOnlyIcon from "@icons/ic-transport-only.svg";
import transportTreatmentIcon from "@icons/ic-transportTreatment.svg";
import treatmentOnlyIcon from "@icons/ic-treatment.svg";
import { ColumnButton, DivToolTipCustom } from "@utils/extra-style";
import SolutionView from "../../../../Solution/SolutionView/SolutionView";
import acceptanceGrey from "@icons/acceptance-grey.svg";
import acceptanceOrange from "@icons/acceptance-orange.svg";
import acceptanceGreen from "@icons/acceptance-green.svg";
import commentIcon from "@icons/ic-comment.svg";
import SolutionAcceptanceView from "../../../../SolutionAcceptance/SolutionAcceptanceView";
import AddEditSolutionAcceptance from "../../../../SolutionAcceptance/AddEditSolutionAcceptance";
import UserInfo from "@utils/UserInfo";
import {
  HeaderWrapper,
  Title,
  SolutionContainer,
  GrayDarkerSpan,
  GraySpan,
  PriceContainer,
  SolutionAllocation,
  Separator,
  SolutionName,
  CommentsTextTitle,
  CommentText,
  GroupComments,
} from "./EnquirySolutions.styled";

import {
  FlexRow,
  GridRow,
  NoEnquiry,
  InfoContainer,
} from "../../EnquiryList.styled";
import "../../EnquiryList.scss";

const EnquirySolutions = (props) => {
  const { t, solutionData, onRefreshData } = props;

  const [currentSolution, setCurrentSolution] = useState([]);
  const [displaySolution, setDisplaySolution] = useState(true);

  const [isSolutionViewPopupVisible, setSolutionViewPopupVisibility] =
    useState(false);

  const [isViewSolutionAcceptancePopUp, setViewSolutionAcceptancePopUp] =
    useState(false);
  const [isAddEditSolutionAcceptancePopUp, setAddEditSolutionAcceptancePopUp] =
    useState(false);
  const [isAddSolutionAcceptanceInPopUp, setAddSolutionAcceptanceInPopUp] =
    useState(false);
  const [acceptanceSolutionId, setAcceptanceSolutionId] = useState("");
  const [centreName, setCentreName] = useState("");
  const [supplierName, setSupplierName] = useState("");
  const [isEditSolutionAcceptancePopUp, setEditSolutionAcceptancePopUp] =
    useState(false);
  const [acceptanceId, setAcceptanceId] = useState("");

  const momentDate = moment(new Date()).format("YYYY-MM-DD");
  const currentDate = new Date(momentDate).getTime();
  const countryInfo = UserInfo.countryInfo();

  const onSolutionViewClose = () => {
    setSolutionViewPopupVisibility(false);
  };

  const onSolutionNameClick = (data) => {
    setCurrentSolution(data);
    setSolutionViewPopupVisibility(true);
  };

  const displayToggle = () => {
    setDisplaySolution(!displaySolution);
  };

  const typeColor = {
    7: "#008395",
    8: "#32A728",
    9: "#32A728",
  };

  let validSolutionCount = 0;

  const onSolutionAcceptanceClick = (id, centreInfo) => {
    setAcceptanceSolutionId(id);
    setSupplierName(centreInfo?.supplierName);
    setCentreName(centreInfo?.companyName);
    setViewSolutionAcceptancePopUp(true);
  };

  const onCloseAcceptanceView = () => {
    setAcceptanceSolutionId("");
    setSupplierName("");
    setCentreName("");
    setViewSolutionAcceptancePopUp(false);
    onRefreshData(true);
  };

  const onSolutionAddEditAcceptanceClick = (id, centreInfo) => {
    setAcceptanceSolutionId(id);
    setSupplierName(centreInfo?.supplierName);
    setCentreName(centreInfo?.companyName);
    setAddEditSolutionAcceptancePopUp(true);
  };

  const onCloseAddEditAcceptanceView = () => {
    setAcceptanceSolutionId("");
    setSupplierName("");
    setCentreName("");
    setAddEditSolutionAcceptancePopUp(false);
  };

  const onSolutionEditAcceptanceClick = () => {
    setViewSolutionAcceptancePopUp(false);
    setEditSolutionAcceptancePopUp(true);
  };

  const onCloseEditAcceptanceView = () => {
    setEditSolutionAcceptancePopUp(false);
    setViewSolutionAcceptancePopUp(true);
  };

  const onSolutionAddAcceptanceClick = () => {
    setViewSolutionAcceptancePopUp(false);
    setAddEditSolutionAcceptancePopUp(true);
    setAddSolutionAcceptanceInPopUp(true);
  };

  const onCloseAddAcceptanceView = () => {
    setAddEditSolutionAcceptancePopUp(false);
    setViewSolutionAcceptancePopUp(true);
    setAddSolutionAcceptanceInPopUp(false);
  };

  const getAcceptanceInfo = (acceptanceInfo) => {
    let acceptanceIcon = acceptanceOrange;
    acceptanceInfo.map((acceptance) => {
      const validityStartDate = new Date(acceptance.validityStart).getTime();
      const validityEndDate = new Date(acceptance.validityEnd).getTime();
      if (
        acceptance.isActive === 1 &&
        parseInt(validityEndDate, 10) >= parseInt(currentDate, 10) &&
        parseInt(currentDate, 10) >= parseInt(validityStartDate, 10)
      ) {
        acceptanceIcon = acceptanceGreen;
      }
    });
    return acceptanceIcon;
  };

  const getAcceptanceText = (acceptanceInfo) => {
    let acceptanceText = t("SOLUTION_ACCEPTANCE_NOT_VALID_TOOLTIP");
    acceptanceInfo.map((acceptance) => {
      const validityStartDate = new Date(acceptance.validityStart).getTime();
      const validityEndDate = new Date(acceptance.validityEnd).getTime();
      if (
        acceptance.isActive === 1 &&
        parseInt(validityEndDate, 10) >= parseInt(currentDate, 10) &&
        parseInt(currentDate, 10) >= parseInt(validityStartDate, 10)
      ) {
        acceptanceText = t("SOLUTION_ACCEPTANCE_VALID_TOOLTIP");
      }
    });
    return acceptanceText;
  };

  const getColumnInfo = (
    needSolutionAcceptance,
    internalComment,
    quoteComment
  ) => {
    let column = "75% 10% auto";
    if (internalComment || quoteComment) {
      column = "73% auto 10% auto";
    }
    if (needSolutionAcceptance) {
      column = "auto 75% 10% auto";
      if (internalComment || quoteComment) {
        column = "auto 73% auto 10% auto";
      }
    }
    return column;
  };

  return (
    <>
      <HeaderWrapper>
        <FlexRow>
          <Image
            src={chevronBottom}
            alt={t("ENQUIRY_ACTION_TOOLTIP_EDIT")}
            title={t("ENQUIRY_ACTION_TOOLTIP_EDIT")}
            className="enquiry-listing__image-icon"
            onClick={displayToggle}
          />
          <Title>{t("ENQUIRY_SOLUTIONS")}</Title>
        </FlexRow>
      </HeaderWrapper>
      <SolutionContainer display={displaySolution ? "block" : "none"}>
        <GridRow>
          {solutionData?.length !== "" &&
            solutionData?.map((data, index) => {
              let selectedTransportPrice =
                data?.solutionTransportPrices?.filter(
                  (price) => price.selectedPrice
                );
              if ([7, 8, 9].includes(data.solutionStatus.id))
                validSolutionCount += 1;
              return (
                <React.Fragment key={"enquirySolution_" + index}>
                  {index !== 0 &&
                    [7, 8, 9].includes(data.solutionStatus.id) && (
                      <Separator></Separator>
                    )}
                  {[7, 8, 9].includes(data.solutionStatus.id) && (
                    <GridRow
                      column={getColumnInfo(
                        countryInfo.country.needSolutionAcceptance,
                        data.internalComment,
                        data.quoteComment
                      )}
                      gap="0rem"
                    >
                      {!!countryInfo.country.needSolutionAcceptance && (
                        <GridRow
                          style={{ width: "30px" }}
                          alignContent="center"
                        >
                          {data?.acceptances?.length === 0 &&
                            parseInt(data?.solutionStatus?.id, 10) === 7 && (
                              <Image
                                className="deleteImage"
                                src={acceptanceGrey}
                                alt={t("SOLUTION_NO_ACCEPTANCE_TOOLTIP")}
                                title={t("SOLUTION_NO_ACCEPTANCE_TOOLTIP")}
                                styles={{
                                  width: "22px",
                                  marginRight: "8px",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  onSolutionAddEditAcceptanceClick(
                                    data.id,
                                    data.centre
                                  )
                                }
                              />
                            )}
                          {data?.acceptances?.length > 0 &&
                            parseInt(data?.solutionStatus?.id, 10) === 7 && (
                              <Image
                                className="acceptanceIcon"
                                src={getAcceptanceInfo(data.acceptances)}
                                alt={getAcceptanceText(data.acceptances)}
                                title={getAcceptanceText(data.acceptances)}
                                styles={{
                                  width: "22px",
                                  marginRight: "8px",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  onSolutionAcceptanceClick(
                                    data.id,
                                    data.centre
                                  )
                                }
                              />
                            )}
                        </GridRow>
                      )}
                      <GridRow gap="0rem">
                        <GridRow column="auto 1fr" gap="0rem">
                          <SolutionName
                            id={`enquiry-tooltip-id${data.id}`}
                            onClick={() => onSolutionNameClick(data)}
                          >
                            #{data?.id ?? ""} -{" "}
                            {data?.priceType === 3 && data.haulier?.companyName}
                            {data?.priceType !== 3 && (
                              <>
                                {data?.centre?.supplierName
                                  ? "[" + data?.centre?.supplierName + "]"
                                  : ""}
                                {data?.centre?.companyName
                                  ? " - " + data?.centre?.companyName
                                  : ""}
                                {data?.centreProduct?.product?.name
                                  ? " - " + data?.centreProduct?.product?.name
                                  : ""}
                              </>
                            )}
                          </SolutionName>
                        </GridRow>
                        <InfoContainer>
                          {data.priceType === 3 && (
                            <PriceContainer>
                              <Image
                                src={transportOnlyIcon}
                                alt={t("TRANSPORT_ONLY")}
                                title={t("TRANSPORT_ONLY")}
                                className="enquiry-listing__image-icon"
                              />
                              <GrayDarkerSpan>
                                {selectedTransportPrice?.[0].price +
                                  selectedTransportPrice?.[0].currency.symbol +
                                  "/" +
                                  t(selectedTransportPrice?.[0].unit) +
                                  " - "}{" "}
                              </GrayDarkerSpan>
                              <GraySpan>
                                {selectedTransportPrice?.[0].transportType.name}
                              </GraySpan>
                            </PriceContainer>
                          )}
                          {data.priceType === 4 && (
                            <PriceContainer>
                              <Image
                                src={treatmentOnlyIcon}
                                alt={t("TREATMENT_ONLY")}
                                title={t("TREATMENT_ONLY")}
                                className="enquiry-listing__image-icon"
                              />
                              <GrayDarkerSpan>
                                {data?.solutionTreatmentPrices.length >= 0 &&
                                  data?.solutionTreatmentPrices?.[0]?.price +
                                    data?.solutionTreatmentPrices?.[0]?.currency
                                      .symbol +
                                    "/" +
                                    t(data?.solutionTreatmentPrices?.[0]?.unit)}
                              </GrayDarkerSpan>
                            </PriceContainer>
                          )}
                          {data.priceType === 1 && (
                            <>
                              <PriceContainer>
                                <Image
                                  src={treatmentOnlyIcon}
                                  alt={t("TREATMENT_ONLY")}
                                  title={t("TREATMENT_ONLY")}
                                  className="enquiry-listing__image-icon"
                                />
                                <GrayDarkerSpan>
                                  {data?.solutionTreatmentPrices?.[0].price +
                                    data?.solutionTreatmentPrices?.[0].currency
                                      .symbol +
                                    "/" +
                                    t(data?.solutionTreatmentPrices?.[0].unit)}
                                </GrayDarkerSpan>
                              </PriceContainer>

                              <PriceContainer>
                                <Image
                                  src={transportOnlyIcon}
                                  alt={t("TRANSPORT_ONLY")}
                                  title={t("TRANSPORT_ONLY")}
                                  className="enquiry-listing__image-icon"
                                />
                                <GrayDarkerSpan>
                                  {selectedTransportPrice?.[0].price +
                                    selectedTransportPrice?.[0].currency
                                      .symbol +
                                    "/" +
                                    t(selectedTransportPrice?.[0].unit) +
                                    " - "}
                                </GrayDarkerSpan>
                                <GraySpan>
                                  {
                                    selectedTransportPrice?.[0].transportType
                                      .name
                                  }
                                </GraySpan>
                              </PriceContainer>
                            </>
                          )}
                          {data.priceType === 2 && (
                            <PriceContainer>
                              <Image
                                height="25px"
                                width="45px"
                                src={transportTreatmentIcon}
                                alt={t("TREATMENT_TRANSPORT_PRICE")}
                                title={t("TREATMENT_TRANSPORT_PRICE")}
                                className="enquiry-listing__image-icon"
                                styles={{
                                  height: "25px !important",
                                  width: "45px !important",
                                }}
                              />
                              <GrayDarkerSpan>
                                {selectedTransportPrice?.[0].price +
                                  selectedTransportPrice?.[0].currency.symbol +
                                  "/" +
                                  t(selectedTransportPrice?.[0].unit) +
                                  " - "}
                              </GrayDarkerSpan>
                              <GraySpan>
                                {selectedTransportPrice?.[0].transportType.name}
                              </GraySpan>
                            </PriceContainer>
                          )}
                        </InfoContainer>
                      </GridRow>
                      {(data.internalComment || data.quoteComment) && (
                        <GridRow alignItems="center">
                          <Image
                            src={commentIcon}
                            alt="comment"
                            styles={{ width: "24px", cursor: "pointer" }}
                            id={`site-enquiry-solution-comment-${data.id}`}
                          />
                          <Tooltip
                            anchorSelect={`#site-enquiry-solution-comment-${data.id}`}
                            style={DivToolTipCustom}
                            // isOpen={true}
                          >
                            <GroupComments>
                              <GridRow gap="0rem">
                                {data.internalComment && (
                                  <>
                                    <CommentsTextTitle>
                                      {t(
                                        "SOLUTION_VIEW_PURCHASE_PRICE_ASSUMPTION"
                                      )}{" "}
                                      :
                                    </CommentsTextTitle>
                                    <CommentText>
                                      {data.internalComment ?? ""}
                                    </CommentText>
                                  </>
                                )}
                                {data.quoteComment && (
                                  <>
                                    <CommentsTextTitle>
                                      {t(
                                        "SOLUTION_VIEW_SPECIFIC_CONDITIONS_CLIENT"
                                      )}{" "}
                                      :
                                    </CommentsTextTitle>
                                    <CommentText>
                                      {data.quoteComment ?? ""}
                                    </CommentText>
                                  </>
                                )}
                              </GridRow>
                            </GroupComments>
                          </Tooltip>
                        </GridRow>
                      )}
                      <GridRow alignItems="center">
                        <SolutionAllocation>
                          {data.allocation !== null && data.allocation + "%"}
                        </SolutionAllocation>
                      </GridRow>
                      <GridRow alignItems="center">
                        <ColumnButton
                          height="30px"
                          border={typeColor[data.solutionStatus.id]}
                          background={typeColor[data.solutionStatus.id]}
                          marginLeft="30px"
                          padding="2px 4px 2px 4px"
                        >
                          <span>
                            {t("SOLUTION_STATUS_" + data.solutionStatus.name)}
                          </span>
                        </ColumnButton>
                      </GridRow>
                    </GridRow>
                  )}
                </React.Fragment>
              );
            })}
          {validSolutionCount === 0 && (
            <GridRow column="1fr">
              <NoEnquiry>{t("ENQUIRY_NO_SOLUTIONS")}</NoEnquiry>
            </GridRow>
          )}
        </GridRow>
        {isSolutionViewPopupVisible && (
          <SolutionView
            onClose={onSolutionViewClose}
            id={currentSolution.id}
            solutionData={currentSolution}
            // onEdit={editSolution}
            isEditBtnVisible={false}
          />
        )}
      </SolutionContainer>
      {isViewSolutionAcceptancePopUp && (
        <SolutionAcceptanceView
          solutionId={acceptanceSolutionId}
          onClose={onCloseAcceptanceView}
          supplierName={supplierName}
          centreName={centreName}
          onSolutionEditAcceptanceClick={onSolutionEditAcceptanceClick}
          setAcceptanceId={setAcceptanceId}
          onSolutionAddAcceptanceClick={onSolutionAddAcceptanceClick}
        />
      )}
      {isAddEditSolutionAcceptancePopUp && (
        <AddEditSolutionAcceptance
          solutionId={acceptanceSolutionId}
          onClose={
            isAddSolutionAcceptanceInPopUp
              ? onCloseAddAcceptanceView
              : onCloseAddEditAcceptanceView
          }
          supplierName={supplierName}
          centreName={centreName}
          updateRefeshStatus={onRefreshData}
          isAddSolutionAcceptanceInPopUp={isAddSolutionAcceptanceInPopUp}
        />
      )}
      {isEditSolutionAcceptancePopUp && (
        <AddEditSolutionAcceptance
          solutionId={acceptanceSolutionId}
          onClose={onCloseEditAcceptanceView}
          supplierName={supplierName}
          centreName={centreName}
          isEditMode
          id={acceptanceId}
        />
      )}
    </>
  );
};

EnquirySolutions.propTypes = {};
export default withTranslation()(EnquirySolutions);
